'use client'

import { useMemo, useState } from 'react'
import dynamic from 'next/dynamic'

import { DonationCard } from 'components/DonationCard'
import { Button } from 'components/Global/Button'

const ResponsiveMasonry: any = dynamic(
  () => import('react-responsive-masonry').then((mod) => mod.ResponsiveMasonry),
  { ssr: false }
)

const Masonry: any = dynamic(() => import('react-responsive-masonry'), {
  ssr: false,
})

export const DonationGrid = ({ cards }) => {
  const categories: any[] = useMemo(() => {
    const set = cards.reduce((acc, card) => {
      card.categories?.forEach((category) => {
        acc.add(category)
      })
      return acc
    }, new Set())
    return Array.from(set) ?? []
  }, [cards])

  const [activeCategory, setActiveCategory] = useState<
    (typeof categories)[number] | 'all'
  >('all')

  const updateCategory = (category) => {
    if (category === 'all') {
      return setActiveCategory('all')
    }

    if (category === activeCategory) {
      return setActiveCategory('all')
    }

    return setActiveCategory(category)
  }

  return (
    <div className="p-20 pt-60 md:pt-80">
      <div className="scrollbar-hidden -mx-20 mb-10 w-[calc(100%+40px)] overflow-x-scroll overscroll-contain whitespace-nowrap px-20 pb-10 md:mx-0 md:flex md:w-full md:px-0">
        <button
          onClick={() => updateCategory('all')}
          className={`background-blur mr-6 inline-block rounded-6 px-20 py-10 text-darkGray transition-all ${
            activeCategory === 'all' ? 'opacity-100' : 'opacity-50'
          }`}
        >
          All
        </button>
        {categories.map((category) => {
          return (
            <Button
              key={category}
              className={`background-blur mr-6 inline-block transition-all ${
                activeCategory === category ? 'opacity-100' : 'opacity-50'
              }`}
              active={activeCategory === category}
              onClick={() => updateCategory(category)}
            >
              {category}
            </Button>
          )
        })}
      </div>
      <ResponsiveMasonry columnsCountBreakPoints={{ 350: 1, 750: 2, 900: 3 }}>
        <Masonry>
          {cards
            .filter((card) =>
              activeCategory !== 'all'
                ? card.categories?.includes(activeCategory)
                : true
            )
            .map((card) => {
              return <DonationCard key={card._id} {...card} />
            })}
        </Masonry>
      </ResponsiveMasonry>
    </div>
  )
}
